export const TOKEN_KEY = "llc_admin_token";
export const authHeader = (t) => ({ headers: { Authorization: `Bearer ${t}` } });
export const errText = (ex) => {
  const d = ex.response?.data?.detail;
  if (Array.isArray(d)) return d.map((x) => x.msg).join(" ");
  return typeof d === "string" ? d : "Something went wrong.";
};
export const currentEdition = () => {
  const d = new Date();
  return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}`;
};
export const editionLabel = (e) => new Date(`${e}-01T00:00:00`).toLocaleDateString("en-IN", { month: "long", year: "numeric" });
export const stageOf = (r) => (r.posted_at ? "posted" : r.packed_at ? "packed" : "to_pack");
